import { getIsSubscriptionVariant } from '@/domain/variant'
import { useProfile } from '@/store/profile'

export const useSelfEmployedPlatformVisibility = () => {
    const profile = useProfile()

    const shouldDisplaySelfEmployedPlatform = profile.hasSubscription || getIsSubscriptionVariant(profile.variant)

    return {
        shouldDisplaySelfEmployedPlatform,
    }
}
